import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 32 32'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M29.855 7.969c-1.431-2.451-3.372-4.392-5.823-5.823s-5.128-2.146-8.031-2.146c-2.903 0-5.58 0.715-8.031 2.146s-4.392 3.371-5.823 5.823c-1.431 2.451-2.146 5.129-2.146 8.031s0.715 5.58 2.146 8.031c1.431 2.451 3.372 4.392 5.823 5.823s5.128 2.146 8.031 2.146c2.903 0 5.58-0.715 8.031-2.146s4.392-3.372 5.823-5.823c1.43-2.451 2.146-5.129 2.146-8.031s-0.715-5.58-2.145-8.031v0zM25.813 21.688c-1.014 1.736-2.389 3.111-4.125 4.125s-3.632 1.52-5.688 1.52c-2.055 0-3.951-0.507-5.688-1.52s-3.111-2.389-4.125-4.125c-1.014-1.736-1.521-3.632-1.521-5.688s0.507-3.951 1.521-5.688c1.014-1.736 2.389-3.111 4.125-4.125s3.632-1.521 5.688-1.521c2.056 0 3.951 0.507 5.688 1.521s3.111 2.389 4.125 4.125 1.52 3.632 1.52 5.688c0 2.056-0.507 3.951-1.52 5.688zM18 8h-1.334c-0.195 0-0.354 0.063-0.479 0.187s-0.187 0.285-0.187 0.479v7.333h-4.667c-0.195 0-0.354 0.062-0.479 0.187s-0.187 0.285-0.187 0.479v1.333c0 0.195 0.062 0.354 0.187 0.479s0.285 0.187 0.479 0.187h6.667c0.194 0 0.354-0.062 0.479-0.187s0.188-0.285 0.188-0.479v-9.333c0-0.194-0.063-0.354-0.188-0.479s-0.285-0.187-0.479-0.187z'
    />
  </svg>
)

export default SVG